export interface CropOption {
  key: string;
  label: string;
  raw?: string;
}

const CROP_ALIASES: Record<string, string> = {
  avo: 'Avocado',
  avocadoes: 'Avocado',
  avocados: 'Avocado',
  avacado: 'Avocado',
  avocardo: 'Avocado',
  macademia: 'Macadamia',
  macadamias: 'Macadamia',
  maize: 'Maize',
  corn: 'Maize',
  bean: 'Beans',
  beans: 'Beans',
  carrot: 'Carrots',
  carrots: 'Carrots',
  mangos: 'Mango',
  mangoes: 'Mango',
};

export const cropKey = (value?: string | null): string =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const toTitleCase = (value: string): string =>
  value
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

export const normalizeCropName = (value?: string | null): string => {
  const key = cropKey(value);
  if (!key) return '';
  return CROP_ALIASES[key] || toTitleCase(key);
};

export const buildCropOptions = (values: Array<string | null | undefined>): CropOption[] => {
  const map = new Map<string, CropOption>();
  values.forEach((value) => {
    const label = normalizeCropName(value);
    const key = cropKey(label);
    if (!key || map.has(key)) return;
    map.set(key, { key, label, raw: value || undefined });
  });
  return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
};
